// npm packages
import React, { Suspense } from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Route, Switch, Redirect } from 'react-router';

import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client/react';
import { ConfigProvider } from 'antd';
import en_US from 'antd/lib/locale-provider/en_US';
//  project files
import { Loader, ErrorBoundary } from 'components';
import App from './routes/app';
import { getRouterData } from './common/router';
import store, { history } from 'meeopp-redux/store';
import { apolloClient } from './graphql/apollo-client';
import './themes/index.less';

const Root = () => {
  const routerData = getRouterData();

  return (
    <ErrorBoundary>
      <ConfigProvider locale={en_US}>
        <Provider store={store}>
          <ApolloProvider client={apolloClient}>
            <ConnectedRouter history={history}>
              <App>
                <Suspense fallback={<Loader spinning={true} fullScreen={true} />}>
                  <Switch>
                    {Object.keys(routerData).map((path) => {
                      const route = routerData[path];
                      const { component: RouteComponent, exact = false, routes = [] } = route;
                      return (
                        <Route key={path} path={path} exact={exact}>
                          <RouteComponent routes={routes} />
                        </Route>
                      );
                    })}
                    <Redirect from="/" to="/organization/home" />
                  </Switch>
                </Suspense>
              </App>
            </ConnectedRouter>
          </ApolloProvider>
        </Provider>
      </ConfigProvider>
    </ErrorBoundary>
  );
};

export default Root;
